module.exports = __webpack_public_path__ + "static/media/whole-textlogo.16d40e84.svg";